export default {
  'launchpad.title': 'Launchpad',
  'launchpad.biconomy': 'Biconomy Launchpad GameFi, NFTs And More...',
  'launchpad.spezializing': 'Spezializing on GameFi blockchain projects, we make earning fun and playing profitable',
  'launchpad.card_title_1': 'Financing',
  'launchpad.card_text_1': 'We help you raise funds to cover your project costs',
  'launchpad.card_title_2': 'Metaverse Ecosystem',
  'launchpad.card_text_2': 'We connect you with business partners across the world',
  'launchpad.card_title_3': 'Project Promotion',
  'launchpad.card_text_3': 'We help your project be noticed in crypto communities',
  'launchpad.learn': 'Learn more and apply',
  'launchpad.gameFi': 'A LAUNCHPAD SPECIALIZING IN GAMEFI PROJECTS',
  'launchpad.let': 'Let’s revolutionize the digital economy together',
  'launchpad.project':
    'Projects that are launched on Biconomy Launchpad will be listed and have world-class liquidity in multiple trading pairs.Token will immediately be distributed to a large user base that hold it. Project will receive extensive support and have access to all areas of the Biconomy ecosystem.',
  'launchpad.apply': 'Apply to Launch Now',
  'launchpad.get': 'Getting rich is fun with Biconomy',
  'launchpad.become': 'Become part of our community of digital enthusiasts and open up a new world for you',
  'launchpad.unit': 'Please input an amount greater than 0',
  'launchpad.Insufficient': 'Insufficient balance',
};
